// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2rc77","subheader":"ReorderModal_subheader__2rltv","listWrap":"ReorderModal_listWrap__2Z1R1"};